<template>
    <div>
        <kgr-loading
            v-if="loading"
            :inline="true"
        />
        <select
            v-else
            v-model="selectedId"
            class="kgr-select"
            @change="onChange()"
        >
            <option
                :value="null"
                class="kgr-select__option"
            >
                {{ $t('Nicht zugewiesen') }}
            </option>
            <option
                v-for="careCost in careCostsHourly"
                :value="careCost.id"
                class="kgr-select__option"
            >
                {{ careCost.title }}
            </option>
        </select>
    </div>
</template>

<script>
import CareCostHourly from '../../../../js/dto/CareCostHourly';
import CareCostRepository from '../../../../js/repository/CareCostRepository';
import Loading from '../../Loading.vue';

export default {
    components: {
        'kgr-loading': Loading,
    },
    props: {
        selected: {
            type: CareCostHourly,
            required: false,
        },
    },
    data() {
        return {
            loading: true,
            selectedId: null,
            careCostsHourly: [],
        };
    },
    watch: {
        selected(selected) {
            this.selectedId = selected ? selected.id : null;
        },
    },
    mounted() {
        this.selectedId = this.selected ? this.selected.id : null;
        CareCostRepository.findAll()
            .then(
                (careCostsHourly) => {
                    this.careCostsHourly = careCostsHourly;
                    this.loading = false;
                },
            )
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        onChange() {
            this.$emit('change', this.careCostsHourly.filter((careCostHourly) => careCostHourly.id === this.selectedId)[0]);
        },
    },
};
</script>
